export default {
  number: '+4733222970',
  display: '33 - 22 29 70',
  currency: 'NOK',
  tracking: {},
};
